import { css, unsafeCSS } from 'chipta-libs/main.js';
import { litStyle } from 'lit-element-style';


export const basicIconStyle = litStyle(css`

  svg {
    display: block;
    stroke: ${unsafeCSS(_themeData.body_color)};
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    cursor: pointer;
    width: 50px;
  }

`);
